import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import { ParameterField } from '../../../../_common/platform/tsx/ParameterField';
import StringField from '../../../../_common/platform/tsx/StringField';
import NumberSpinnerExtended from '../../../../_common/platform/tsx/NumberSpinnerExtended';
import { ColorBoxField } from '../../../../_common/platform/tsx/ColorBoxField';
import { DataQuerySingleValueField } from '../../../../_common/application/tsx/DataQuerySingleValueField';
import * as DateTimeFunctions from '../../../../_common/platform/ts/DateTimeFunctions';
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import { CHART_CONSTANT_LINES } from '../chartConstants';
import { IParameterFieldBaseOptions } from '../../../../_common/platform/ts/ParameterFieldBase';
import { ChartPropsManager } from '../ChartPropsManager';

class ChartConstantLinesFieldRow extends React.Component<
    {
        value?;
        values?;
        i?: number;
        secondaryAxisArr;
        prohibitAsPercent_byAxisType_byAxisObjX?;
        prohibitAsPercent_byAxisType_byAxisObjY?;
        prohibitedAsPercent_byAttrQuery_X_multi?: boolean;
        prohibitedAsPercent_byAttrQuery_Y_multi?: boolean;
        themeFields_forDefaultColors?;
        themeObj: appTheme.IValuesCollection;
        glob: IGlob;

        onChange(value, param2): void;
        onRemove?(index: number): void;
        onHeaderClick?(); // Not used.
    },
    { selectedPredefinedConstantLine }
> {
    private references: {
        labelVerticalAlignment?: HTMLElement; // HTMLDivElement;
        labelHorizontalAlignment?: HTMLElement; // HTMLDivElement;
        type?: HTMLElement; // HTMLDivElement;
        dashStyle?: HTMLElement; // HTMLDivElement;
        asPercent?: HTMLElement; // HTMLDivElement;
        fromDataSource?: HTMLElement; // HTMLDivElement;
        labelPosition?: HTMLElement; // HTMLDivElement;
        selectConstantLine?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        this.state = {
            selectedPredefinedConstantLine: null //LL: for fictiv row
        };
    }

    normalize(value) {
        if (value.type == null) {
            delete value.label;
            delete value.labelHorizontalAlignment;
            delete value.labelVerticalAlignment;
            delete value.color;
            delete value.fontColor;
            delete value.labelPosition;
            delete value.value;
            delete value.dashStyle;
            delete value.asPercent;
            delete value.width;

            delete value.name;

            return;
        }

        //LL: wrong
        //if (value.value != null) {
        //    value.value = $.trim(value.value);
        //}

        let find: any;

        find = _.find(CHART_CONSTANT_LINES.labelVerticalAlignment, function (val) {
            return val === value.labelVerticalAlignment;
        });
        if (find == null) {
            delete value.labelVerticalAlignment;
        }

        find = _.find(CHART_CONSTANT_LINES.labelHorizontalAlignment, function (val) {
            return val === value.labelHorizontalAlignment;
        });
        if (find == null) {
            delete value.labelHorizontalAlignment;
        }

        find = _.find(CHART_CONSTANT_LINES.dashStyle, function (val) {
            return val.value === value.dashStyle;
        });
        if (find == null) {
            delete value.dashStyle;
        }
    }

    processLabelVerticalAlignmentChange = (e) => {
        let val = (this.references.labelVerticalAlignment as HTMLInputElement).value;

        //LL: 27.05.20: for inheritance, for clearElem -> null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});

        if (val === 'none' || val == null) {
            delete obj.labelVerticalAlignment;
        } else {
            obj.labelVerticalAlignment = val;
        }

        this.handleValueChange(obj);
    };

    processLabelHorizontalAlignmentChange = (e) => {
        let val = (this.references.labelHorizontalAlignment as HTMLInputElement).value;

        //LL: 27.05.20: for inheritance, for clearElem -> null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});

        if (val === 'none' || val == null) {
            delete obj.labelHorizontalAlignment;
        } else {
            obj.labelHorizontalAlignment = val;
        }

        this.handleValueChange(obj);
    };

    processTypeChange = (e) => {
        let val = (this.references.type as HTMLInputElement).value;

        //LL: 27.05.20: for inheritance, for clearElem -> null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});

        if (val === 'none' || val == null) {
            delete obj.type;
        } else {
            obj.type = val;
        }

        this.handleValueChange(obj);
    };

    processLabelChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.label;
        } else {
            obj.label = val;
        }
        this.handleValueChange(obj);
    };

    processValueChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.value;
        } else {
            obj.value = val;
        }
        this.handleValueChange(obj);
    };

    processDataQueryChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.dataQuery;
        } else {
            obj.dataQuery = val;
        }
        this.handleValueChange(obj);
    };

    processDashStyleChange = (e) => {
        let val = (this.references.dashStyle as HTMLInputElement).value;

        //LL: 27.05.20: for inheritance, for clearElem -> null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.dashStyle;
        } else {
            obj.dashStyle = val;
        }
        this.handleValueChange(obj);
    };

    processAsPercentChange = (e) => {
        let val = (this.references.asPercent as HTMLInputElement).checked;

        //LL: 27.05.20: for inheritance, for clearElem -> null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.asPercent;
        } else {
            obj.asPercent = val;
        }
        this.handleValueChange(obj);
    };

    processFromDataSourceChange = (e) => {
        let val = (this.references.fromDataSource as HTMLInputElement).checked;

        //LL: 27.05.20: for inheritance, for clearElem -> null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.fromDataSource;
        } else {
            obj.fromDataSource = val;
        }
        this.handleValueChange(obj);
    };

    processWidthChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.width;
        } else {
            obj.width = val;
        }
        this.handleValueChange(obj);
    };

    processLabelPositionChange = (e) => {
        let val = (this.references.labelPosition as HTMLInputElement).value;

        //LL: 27.05.20: for inheritance, for clearElem -> null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.labelPosition;
        } else {
            obj.labelPosition = val;
        }
        this.handleValueChange(obj);
    };

    processFontColorChange_ColorBox = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.fontColor;
        } else {
            obj.fontColor = val;
        }
        this.handleValueChange(obj);
    };

    processColorChange_ColorBox = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.color;
        } else {
            obj.color = val;
        }
        this.handleValueChange(obj);
    };

    handleValueChange(value) {
        this.normalize(value);

        let param2: any = this.props.i; // for updateRow
        if (this.props.i == null && this.state != null) {
            //LL: for addRow
            param2 = this.state.selectedPredefinedConstantLine;
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, param2);
        }
    }

    handleRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i);
        }
    };

    getRemoveButton(value) {
        if (value.type == null) {
            return;
        }

        if (value.inherited === true) {
            return <span className="glyphicon glyphicon-arrow-down"></span>;
        }

        return <span className="glyphicon glyphicon-remove" onClick={this.handleRemove}></span>;
    }

    processNameChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.name = val;
        this.handleValueChange(obj);
    };

    getName(value) {
        if (value.type == null) {
            return;
        }

        let displayVal = value.name || '';
        return (
            <StringField
                onChange={this.processNameChange}
                value={displayVal}
                applyOnEnter={true}
                changeOnBlurOnly={true}
            />
        );
    }

    getLabel(value) {
        if (value.type == null) {
            return;
        }
        return <StringField onChange={this.processLabelChange} value={value.label || ''} />;
    }

    getType(value) {
        let displayVal = value.type || 'none';

        let secondaryAxisArr = [];
        if (this.props.secondaryAxisArr != null) {
            secondaryAxisArr = this.props.secondaryAxisArr;
        }

        let arr = CHART_CONSTANT_LINES.constantLineType.slice(0); // ['arguments', 'values']

        //LL: 02.06.20: add 'not used' type => will not used in Chart
        arr.push(CHART_CONSTANT_LINES.notUsedType);

        let removedAxisOption;
        if (displayVal != 'none') {
            let ind = _.indexOf(arr, displayVal);
            let isAux = ind < 0;
            let auxNotExist = _.indexOf(secondaryAxisArr, displayVal) < 0;
            if (isAux && auxNotExist) {
                removedAxisOption = (
                    <option key={displayVal} value={displayVal} disabled={true}>
                        {displayVal + ' removed'}
                    </option>
                );
            }
        }

        arr = arr.concat(secondaryAxisArr); //  main + aux

        let options = _.map(arr, function (value) {
            return (
                <option key={value} value={value}>
                    {value}
                </option>
            );
        });

        //LL: 02.06.20: show 'none' only when no value
        let noneOption;

        if (displayVal === 'none') {
            noneOption = (
                <option key="none" value="none" disabled={true}>
                    {'none'}
                </option>
            );
        }

        let title = '';
        if (value.type == null) {
            title = 'Choose actual Axis to create a Constant Line';
        }

        let style2: any = {};
        if (removedAxisOption != null) {
            style2 = { borderColor: 'red' }; // color bad, for all items in dropdown
            title = 'Axis is removed';
        }

        return (
            <select
                ref={(input) => {
                    this.references.type = input;
                }}
                className="form-control"
                style={style2}
                onChange={this.processTypeChange}
                value={displayVal}
                title={title}
            >
                {removedAxisOption}
                {noneOption}
                {options}
            </select>
        );
    }

    getAxisType(value) {
        if (value.type == null) {
            return;
        }

        let axisName = value.type;
        let axisType = ChartPropsManager.getAxisType(this.props.values, axisName, this.props.themeObj);

        const defName = 'automatic'; // "default"

        if (axisType == null) {
            axisType = defName;
        }

        let emphasize = false;
        if (axisType === 'discrete' || axisType === defName) {
            emphasize = true;
        }

        let style1: any = {};
        if (emphasize) {
            style1.color = '#1111ee';
        }

        return <span style={style1}>{axisType}</span>;
    }

    getDataType(value) {
        const axisName = value.type;

        if (axisName === 'arguments') {
            return ChartPropsManager.get_argumentAxis_DataType_withTimePart(this.props.values, this.props.glob);
        } else if (axisName === 'values') {
            return ChartPropsManager.get_valueAxis_DataType_withTimePart(this.props.values, this.props.glob);
        }
        //LL: 02.06.20: add 'not used' type => will not used in Chart
        else if (axisName === CHART_CONSTANT_LINES.notUsedType) {
            // nothing
        } else {
            return ChartPropsManager.get_secondaryAxis_DataType_withTimePart(
                this.props.values,
                axisName,
                this.props.themeObj,
                this.props.glob
            );
        }

        return undefined;
    }

    getValue(value, dataType) {
        if (value.type == null) {
            return;
        }

        let fromDataSource = value.fromDataSource != null ? value.fromDataSource : false;

        if (fromDataSource) {
            //let dataQueryValue = value.dataQuery;  // may be null

            //LL: 28.10.19: make copy:  it is array[0] or null
            let dataQueryValue: any = null;
            if (value.dataQuery != null && value.dataQuery.length > 0) {
                let v: any = value.dataQuery[0];
                v = $.extend(true, {}, v); // deep copy
                dataQueryValue = [v];
            }

            return (
                <DataQuerySingleValueField
                    value={dataQueryValue}
                    themeObj={this.props.themeObj}
                    onChange={this.processDataQueryChange}
                    glob={this.props.glob}
                />
            );
        } else {
            let displayVal2 = value.value || '';

            let placeholder = '';
            //if (DateTimeFunctions.isTypeOfDateOrDatetime(dataType)) {
            //    placeholder = 'yyyy-mm-dd hh:mm:ss';
            //}
            //LL: 19.06.24
            if (DateTimeFunctions.isTypeOfDatetime(dataType)) {
                placeholder = 'yyyy-mm-dd hh:mm:ss';
            } else if (DateTimeFunctions.isTypeOfDatePure(dataType)) {
                placeholder = 'yyyy-mm-dd';
            } else if (DateTimeFunctions.isTypeOfTime(dataType)) {
                placeholder = 'hh:mm:ss';
            }

            //  NEW:
            let title = placeholder !== '' ? placeholder : null;

            return (
                <StringField
                    onChange={this.processValueChange}
                    value={displayVal2}
                    placeholder={placeholder}
                    title={title}
                />
            );
        }
    }

    getDashStyle(value) {
        if (value.type == null) {
            return;
        }

        let displayVal = value.dashStyle; // || 'none';

        let options = _.map(CHART_CONSTANT_LINES.dashStyle, function (val) {
            return (
                <option key={val.value} value={val.value}>
                    {val.display}
                </option>
            );
        });

        return (
            <select
                ref={(input) => {
                    this.references.dashStyle = input;
                }}
                className="form-control"
                onChange={this.processDashStyleChange}
                value={displayVal}
            >
                {options}
            </select>
        );
    }

    getAsPercent(value) {
        if (value.type == null) {
            return;
        }

        let disabled = false;

        if (value.type === 'arguments') {
            if (!disabled) {
                if (this.props.prohibitAsPercent_byAxisType_byAxisObjX != null) {
                    disabled = this.props.prohibitAsPercent_byAxisType_byAxisObjX;
                }
            }
            if (!disabled) {
                if (this.props.prohibitedAsPercent_byAttrQuery_X_multi != null) {
                    disabled = this.props.prohibitedAsPercent_byAttrQuery_X_multi;
                }
            }
        } else if (value.type === 'values') {
            if (!disabled) {
                if (this.props.prohibitAsPercent_byAxisType_byAxisObjY != null) {
                    disabled = this.props.prohibitAsPercent_byAxisType_byAxisObjY;
                }
            }

            if (!disabled) {
                if (this.props.prohibitedAsPercent_byAttrQuery_Y_multi != null) {
                    disabled = this.props.prohibitedAsPercent_byAttrQuery_Y_multi;
                }
            }
        }

        //LL: 02.06.20: add 'not used' type => will not used in Chart
        else if (value.type === CHART_CONSTANT_LINES.notUsedType) {
            disabled = true;
        }

        //LL: AuxAxis:  similar to Values
        else {
            let axisName = value.type;

            if (!disabled) {
                disabled = ChartPropsManager.prohibitAsPercent_SecondaryValueAxis(
                    this.props.values,
                    axisName,
                    this.props.themeObj,
                    this.props.glob
                );
            }
        }

        return (
            <input
                ref={(input) => {
                    this.references.asPercent = input;
                }}
                type="checkbox"
                disabled={disabled}
                title="only for numeric continuous axis"
                checked={value.asPercent}
                onChange={this.processAsPercentChange}
            />
        );
    }

    getFromDataSource(value) {
        if (value.type == null) {
            return;
        }

        let checkedVal = value.fromDataSource != null ? value.fromDataSource : false;

        return (
            <input
                ref={(input) => {
                    this.references.fromDataSource = input;
                }}
                type="checkbox"
                title="get Value from DataSource defined in 'Additional Data' Tab"
                checked={checkedVal}
                onChange={this.processFromDataSourceChange}
            />
        );
    }

    getWidth(value) {
        if (value.type == null) {
            return;
        }

        return <NumberSpinnerExtended value={value.width} integer={true} min={1} onChange={this.processWidthChange} />;
    }

    getLabelPosition(value) {
        if (value.type == null) {
            return;
        }

        let displayVal = value.labelPosition; // || 'none';

        let options = _.map(['inside', 'outside'], function (val) {
            return (
                <option key={val} value={val}>
                    {val}
                </option>
            );
        });

        return (
            <select
                ref={(input) => {
                    this.references.labelPosition = input;
                }}
                className="form-control"
                onChange={this.processLabelPositionChange}
                value={displayVal}
            >
                {options}
            </select>
        );
    }

    getFontColor(value) {
        if (value.type == null) {
            return;
        }

        let themeObj = this.props.themeObj;
        let themeFields_forDefaultColors = this.props.themeFields_forDefaultColors;

        let defaultColor = '#000000';
        if (
            themeFields_forDefaultColors != null &&
            themeFields_forDefaultColors.defaultColors_static != null &&
            themeFields_forDefaultColors.defaultColors_static.color != null
        ) {
            defaultColor = themeFields_forDefaultColors.defaultColors_static.colorFont;
        }

        let options: any = {
            hideTransparency: true
        };

        let themeFieldForDefault_color =
            themeFields_forDefaultColors != null
                ? themeFields_forDefaultColors.themeFieldForDefault_colorFont_constantLines
                : null;
        let displayVal = value.fontColor || themeObj[themeFieldForDefault_color] || defaultColor;

        let param: any = {
            defaultVal: () => {
                return themeObj[themeFieldForDefault_color] || defaultColor;
            },
            glob: this.props.glob,
            options: options
        };

        return (
            <ParameterField
                key="parameter-field"
                param={param}
                options={{
                    inline: true,
                    noTitle: true,
                    clearable: true,
                    onClear: () => this.processFontColorChange_ColorBox(null)
                }}
                onClick={this.props.onHeaderClick}
                glob={this.props.glob}
            >
                <ColorBoxField
                    value={displayVal}
                    themeObj={themeObj}
                    hideTransparency={true}
                    showText={false}
                    options={options}
                    param={param}
                    onChange={this.processFontColorChange_ColorBox}
                    glob={this.props.glob}
                />
            </ParameterField>
        );
    }

    getColor(value) {
        if (value.type == null) {
            return;
        }

        let themeObj = this.props.themeObj;
        let themeFields_forDefaultColors = this.props.themeFields_forDefaultColors;

        let defaultColor = '#000000';
        if (
            themeFields_forDefaultColors != null &&
            themeFields_forDefaultColors.defaultColors_static != null &&
            themeFields_forDefaultColors.defaultColors_static.color != null
        ) {
            defaultColor = themeFields_forDefaultColors.defaultColors_static.colorLine;
        }

        let options: any = {
            hideTransparency: true
        };

        let themeFieldForDefault_color =
            themeFields_forDefaultColors != null ? themeFields_forDefaultColors.themeFieldForDefault_colorLine : null;
        let displayVal = value.color || themeObj[themeFieldForDefault_color] || defaultColor;

        let param: any = {
            defaultVal: () => {
                return themeObj[themeFieldForDefault_color] || defaultColor;
            },
            glob: this.props.glob,
            options: options
        };

        return (
            <ParameterField
                key="parameter-field"
                param={param}
                options={{
                    inline: true,
                    noTitle: true,
                    clearable: true,
                    onClear: () => this.processColorChange_ColorBox(null)
                }}
                glob={this.props.glob}
            >
                <ColorBoxField
                    value={displayVal}
                    themeObj={themeObj}
                    hideTransparency={false}
                    showText={false}
                    options={options}
                    param={param}
                    onChange={this.processColorChange_ColorBox}
                    glob={this.props.glob}
                />
            </ParameterField>
        );
    }

    getLabelVerticalAlignment(value) {
        if (value.type == null) {
            return;
        }

        let displayVal = value.labelVerticalAlignment; // || 'none';

        let options = _.map(CHART_CONSTANT_LINES.labelVerticalAlignment, function (val) {
            return (
                <option key={val} value={val}>
                    {val}
                </option>
            );
        });

        return (
            <select
                ref={(input) => {
                    this.references.labelVerticalAlignment = input;
                }}
                className="form-control"
                onChange={this.processLabelVerticalAlignmentChange}
                value={displayVal}
            >
                {options}
            </select>
        );
    }

    getLabelHorizontalAlignment(value) {
        if (value.type == null) {
            return;
        }

        let displayVal = value.labelHorizontalAlignment; // || 'none';

        let options = _.map(CHART_CONSTANT_LINES.labelHorizontalAlignment, function (val) {
            return (
                <option key={val} value={val}>
                    {val}
                </option>
            );
        });

        return (
            <select
                ref={(input) => {
                    this.references.labelHorizontalAlignment = input;
                }}
                className="form-control"
                onChange={this.processLabelHorizontalAlignmentChange}
                value={displayVal}
            >
                {options}
            </select>
        );
    }

    processConstantLineChange = (e) => {
        let val = (this.references.selectConstantLine as HTMLInputElement).value;

        if (val === '') {
            //  "none"
            val = null;
        }

        this.setState(
            _.extend(this.state, {
                selectedPredefinedConstantLine: val
            })
        );
    };

    getPredefinedConstantLineList(constantLineList) {
        let selectConstantLineElem;

        if (constantLineList != null && constantLineList.length > 0) {
            let options = _.map(constantLineList, function (item: any) {
                // { item.name + " (" + item.dataType + ")" }
                return (
                    <option key={item.name} value={item.name}>
                        {item.name}
                    </option>
                );
            });

            let constantLineVal = this.state.selectedPredefinedConstantLine || '';

            if (this.state.selectedPredefinedConstantLine == null) {
                options.unshift(
                    <option key={' '} value={''} disabled={true}>
                        {'choose an item'}
                    </option>
                );
            } else {
                options.unshift(
                    <option key={' '} value={''}>
                        {'none'}
                    </option>
                );
            }

            selectConstantLineElem = (
                <select
                    ref={(input) => {
                        this.references.selectConstantLine = input;
                    }}
                    className="form-control"
                    onChange={this.processConstantLineChange}
                    value={constantLineVal}
                >
                    {options}
                </select>
            );
        }

        return selectConstantLineElem;
    }

    render() {
        const value = this.props.value || {};
        //LL: same as in ChartAxisField,  Breaks
        const dataTypeExt = this.getDataType(value);

        let dataType;
        let dataTypePure;
        let dataTimePart;

        if (dataTypeExt != null) {
            dataType = dataTypeExt.type;

            if (dataTypeExt.timePart != null && dataTypeExt.timePart !== 'none') {
                dataType = dataTypeExt.timePart;
            }

            dataTypePure = dataTypeExt.type;
            dataTimePart = dataTypeExt.timePart;
        } else {
            dataType = 's';
            dataTypePure = 's';
        }

        //LL: 01.06.20:  must have "name"   className="cell-name"
        //let tdName =
        //    <td className="cell-name">
        //        { this.getName(value) }
        //    </td>;
        //LL: 19.11.20:  //handle: '.cell-drag' in $(tableBody).sortable
        //    See problem description in getName of ChartBreaksField_inThemes.tsx
        //    (clicking on this (empty) field does not issue onBlur for currently edited <input>)
        let nameElem = this.getName(value);
        let nameClass = 'cell-name';
        if (nameElem != null) {
            nameClass += ' cell-drag';
        }
        let tdName = <td className={nameClass}>{nameElem}</td>;

        //LL: use cell-color for both color and fontColor
        return (
            <tr>
                <td className="cell-remove">{this.getRemoveButton(value)}</td>
                {tdName}
                <td className="cell-type">{this.getType(value)}</td>
                <td className="cell-axisType">{this.getAxisType(value)}</td>
                <td className="cell-label">{this.getLabel(value)}</td>
                <td className="cell-asPercent">{this.getFromDataSource(value)}</td>
                <td className="cell-value">{this.getValue(value, dataType)}</td>
                <td className="cell-asPercent">{this.getAsPercent(value)}</td>
                <td className="cell-dashStyle">{this.getDashStyle(value)}</td>
                <td className="cell-width">{this.getWidth(value)}</td>
                <td className="cell-color">{this.getColor(value)}</td>
                <td className="cell-color">{this.getFontColor(value)}</td>
                <td className="cell-labelPosition">{this.getLabelPosition(value)}</td>
                <td className="cell-labelAlignment">{this.getLabelVerticalAlignment(value)}</td>
                <td className="cell-labelAlignment">{this.getLabelHorizontalAlignment(value)}</td>
            </tr>
        );
    }
}

export interface IChartConstantLinesField_inThemesOptions extends IParameterFieldBaseOptions {
    widgetTypeName?: string;
    widgetValues?;
    themeField_constantLinesLabelPositionDefault;
    themeField_constantLinesDashStyleDefault;
    themeField_constantLinesWidthDefault;
    themeFields_forLabelAlignment;
    themeFieldForConstantLineList?;
    themeFields_forDefaultColors;
    getChartAxisArray_Func(props_values, themeObj: appTheme.IValuesCollection);
    onEvalAuxAxisNames(ChartAxisArrayField);
}

export default class ChartConstantLinesField_inThemes extends React.Component<
    {
        value?;
        border?: boolean;
        options?: IChartConstantLinesField_inThemesOptions;
        themeObj?: appTheme.IValuesCollection;
        glob: IGlob;

        onChange?(value): void;
    },
    {
        forActualChart: boolean;
    }
> {
    private references: {
        tableBody?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        let forActualChart = true; //LL: 28.05.20  false when with standard inheritance, on upper levels
        let props_values = this.getPropsValues();

        if (props_values == null) {
            forActualChart = false; //LL: 28.05.20: when with standard inheritance, on upper levels
        }

        this.state = {
            forActualChart: forActualChart
        };
    }

    private startIndex;

    reorderStart = (e, ui) => {
        this.startIndex = $(ui.item).index();
    };

    reorderStop = (e, ui) => {
        if (this.startIndex == null) {
            return;
        }

        let startIndex = this.startIndex;
        let stopIndex = $(ui.item).index();

        this.startIndex = null;

        //LL: see: https://gist.github.com/avakhov/7b9d2b1a354e59dbfa63
        //   Вызываем cancel, чтобы элементы местами поменял React.js
        //   $(me.getDOMNode()).sortable("cancel");

        let tableBody = this.references.tableBody;
        $(tableBody).sortable('cancel');

        this.processReorder(startIndex, stopIndex);
    };

    componentDidMount() {
        let tableBody = this.references.tableBody;

        $(tableBody).sortable({
            axis: 'y',
            forceHelperSize: true,
            items: 'tr:not(.empty)',
            opacity: 0.8,
            //handle: '.cell-name',
            handle: '.cell-drag', //LL: 19.11.20: in addition to cell-name
            start: this.reorderStart,
            stop: this.reorderStop
        });
    }

    componentWillUnmount() {
        let tableBody = this.references.tableBody;
        $(tableBody).sortable('destroy');
    }

    handleOnStoreChange() {
        this.setState(this.state);
    }

    processReorder(start, stop) {
        if (start === stop) {
            return;
        }

        let value = this.props.value.slice(0);

        let item = value.splice(start, 1);
        value.splice(stop, 0, item[0]);

        this.handleValueChange(value);
    }

    handleValueChange(value) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    _getLabelPositionDefault() {
        //let labelPositionDefault_FieldName = 'axisConstantLines_labelPositionDefault';
        //if ((this.props.options != null) &&
        //    (typeof this.props.options.constantLinesLabelPositionDefault_FieldName === 'string')) {
        //    labelPositionDefault_FieldName = this.props.options.constantLinesLabelPositionDefault_FieldName;
        //}
        //
        //let pos = null;
        //if (this.props.values != null) {
        //    if (this.props.values[labelPositionDefault_FieldName] != null)
        //        pos = this.props.values[labelPositionDefault_FieldName];
        //}

        let pos = 'inside'; //LL: as default for DevExpr

        let themeObj = this.props.themeObj;
        let themeField_constantLinesLabelPositionDefault =
            this.props.options.themeField_constantLinesLabelPositionDefault;
        if (
            themeObj != null &&
            themeField_constantLinesLabelPositionDefault != null &&
            themeObj[themeField_constantLinesLabelPositionDefault] != null
        ) {
            pos = themeObj[themeField_constantLinesLabelPositionDefault];
        }

        return pos;
    }

    _getDashStyleDefault() {
        let dashStyle = null;

        let themeObj = this.props.themeObj;
        let themeField_constantLinesDashStyleDefault = this.props.options.themeField_constantLinesDashStyleDefault;
        if (
            themeObj != null &&
            themeField_constantLinesDashStyleDefault != null &&
            themeObj[themeField_constantLinesDashStyleDefault] != null
        ) {
            dashStyle = themeObj[themeField_constantLinesDashStyleDefault];
        }

        return dashStyle;
    }

    _getWidthDefault() {
        let width = null;

        let themeObj = this.props.themeObj;
        let themeField_constantLinesWidthDefault = this.props.options.themeField_constantLinesWidthDefault;
        if (
            themeObj != null &&
            themeField_constantLinesWidthDefault != null &&
            themeObj[themeField_constantLinesWidthDefault] != null
        ) {
            width = themeObj[themeField_constantLinesWidthDefault];
        }

        return width;
    }

    getPropsValues() {
        let pv;
        if (this.props.options != null && this.props.options.widgetValues != null) {
            if (this.props.options.widgetTypeName === 'pdc-widget-chart') {
                pv = this.props.options.widgetValues;
            }
        }
        return pv;
    }

    _getChartAxisArrayField() {
        let props_values = this.getPropsValues();

        if (props_values == null) {
            return [];
        }

        let ChartAxisArrayFieldValue = [];

        if (this.props.options != null && typeof this.props.options.getChartAxisArray_Func === 'function') {
            ChartAxisArrayFieldValue = this.props.options.getChartAxisArray_Func(props_values, this.props.themeObj);
        }

        return ChartAxisArrayFieldValue;
    }

    addRow = (obj: any, selectedPredefinedConstantLineName?) => {
        let arr = this.props.value.slice(0);
        let labelAlignmentVert_X = 'top';
        let labelAlignmentHoriz_X = 'center';
        let labelAlignmentVert_Y = 'center';
        let labelAlignmentHoriz_Y = 'left';
        let labelAlignmentHoriz_A = 'right'; //LL: now without theme default

        if (this.props.themeObj != null) {
            let themeFields_forLabelAlignment = this.props.options.themeFields_forLabelAlignment;
            if (themeFields_forLabelAlignment != null) {
                if (themeFields_forLabelAlignment.labelAlignmentVert_X != null) {
                    labelAlignmentVert_X = this.props.themeObj[themeFields_forLabelAlignment.labelAlignmentVert_X];
                }
                if (themeFields_forLabelAlignment.labelAlignmentHoriz_X != null) {
                    labelAlignmentHoriz_X = this.props.themeObj[themeFields_forLabelAlignment.labelAlignmentHoriz_X];
                }
                if (themeFields_forLabelAlignment.labelAlignmentVert_Y != null) {
                    labelAlignmentVert_Y = this.props.themeObj[themeFields_forLabelAlignment.labelAlignmentVert_Y];
                }
                if (themeFields_forLabelAlignment.labelAlignmentHoriz_Y != null) {
                    labelAlignmentHoriz_Y = this.props.themeObj[themeFields_forLabelAlignment.labelAlignmentHoriz_Y];
                }
            }
        }

        //LL:  if rotatedXY  ???
        if (obj.type === 'arguments') {
            // looks vertical, if not rotated
            obj.labelHorizontalAlignment = labelAlignmentHoriz_X; //'center';
            obj.labelVerticalAlignment = labelAlignmentVert_X; //'top';
        } else if (obj.type === 'values') {
            // looks horizontal, if not rotated
            obj.labelHorizontalAlignment = labelAlignmentHoriz_Y; //'left';
            obj.labelVerticalAlignment = labelAlignmentVert_Y; //'center';
        }
        //LL: 02.06.20: add 'not used' type => will not used in Chart
        else if (obj.type === CHART_CONSTANT_LINES.notUsedType) {
            //  nothing (is null) or as X  ?
        } else {
            // AuxAxis, looks horizontal, if not rotated
            obj.labelHorizontalAlignment = labelAlignmentHoriz_A; //'right';
            obj.labelVerticalAlignment = labelAlignmentVert_Y; //'center';
        }

        //LL: colors = null to use default from theme
        //LL: set by Default:
        //let c = this._getColorDefault();
        //if (c != null) obj.color = c;
        //let fc = this._getLabelFontColorDefault();
        //if (fc != null) obj.fontColor = fc;

        let pos = this._getLabelPositionDefault();
        if (pos != null) obj.labelPosition = pos;

        let ds = this._getDashStyleDefault();
        if (ds != null) obj.dashStyle = ds;

        obj.asPercent = false;

        let w = this._getWidthDefault();
        if (w != null) obj.width = w;

        let selectedPredefinedConstantLineObj;
        if (selectedPredefinedConstantLineName != null) {
            let themeFieldForConstantLineList = this.props.options.themeFieldForConstantLineList;
            let themeObj = this.props.themeObj;
            if (themeFieldForConstantLineList != null && themeObj != null) {
                let constantLineList = themeObj[themeFieldForConstantLineList];
                if (constantLineList != null && constantLineList.length > 0) {
                    selectedPredefinedConstantLineObj = _.find(constantLineList, function (obj: any) {
                        return obj.name === selectedPredefinedConstantLineName;
                    });
                }
            }
        }

        if (selectedPredefinedConstantLineObj != null) {
            obj = $.extend(true, {}, obj, selectedPredefinedConstantLineObj); // deep copy because of DataSource Start/End Values
            delete obj.name; //LL:  === predefinedName
        }

        arr.push(obj);
        this.handleValueChange(arr);
    };

    changeRow = (obj: any, i) => {
        let arr = this.props.value.slice(0);
        let prev = arr.splice(i, 1, obj)[0];
        this.handleValueChange(arr);
    };

    removeRow = (i) => {
        let arr = this.props.value.slice(0);
        arr.splice(i, 1);
        this.handleValueChange(arr);
    };

    callEvalAuxAxisNames(ChartAxisArrayField) {
        let result = '';

        if (this.props.options != null && typeof this.props.options.onEvalAuxAxisNames === 'function') {
            result = this.props.options.onEvalAuxAxisNames(ChartAxisArrayField);
        }

        return result;
    }

    render() {
        const { options } = this.props;

        let forActualChart = this.state.forActualChart; // false - when with standard inheritance, on upper levels
        let props_values = this.getPropsValues();

        if (props_values == null) {
            //return null;
            //LL: 28.05.20:
            //if (!StandardInheritanceFlag) {  // as old
            //    return null;
            //}
        }

        //let secondaryAxis;
        let secondaryAxisArr = [];
        //let multiAxis = true;
        let chartAxisArrayField = this._getChartAxisArrayField();
        let auxAxisNames = this.callEvalAuxAxisNames(chartAxisArrayField);

        if (auxAxisNames != null && auxAxisNames != '') {
            secondaryAxisArr = auxAxisNames.split(';');
        }
        //secondaryAxis = AuxAxisNames;

        let prohibitedAsPercent_byAxisType_byAxisObjX: boolean;

        if (forActualChart) {
            prohibitedAsPercent_byAxisType_byAxisObjX = ChartPropsManager.prohibitAsPercent_byAxisType_byAxisObjX(
                props_values,
                this.props.themeObj
            );
        }

        let prohibitedAsPercent_byAxisType_byAxisObjY: boolean;
        //  -- prohibit by ValueType:
        let prohibitedAsPercent_byAttrQuery_X_multi: boolean;
        let prohibitedAsPercent_byAttrQuery_Y_multi: boolean;

        if (forActualChart) {
            prohibitedAsPercent_byAxisType_byAxisObjY = ChartPropsManager.prohibitAsPercent_byAxisType_byAxisObjY(
                props_values,
                this.props.themeObj
            );

            prohibitedAsPercent_byAttrQuery_X_multi = ChartPropsManager.prohibitAsPercent_byAttrQuery_X_multi(
                props_values,
                this.props.glob
            );

            prohibitedAsPercent_byAttrQuery_Y_multi = ChartPropsManager.prohibitAsPercent_byAttrQuery_Y_multi(
                props_values,
                this.props.glob
            );
        }

        //LL: "optionThemeOwnAndParent" is from ThemeField.tsx  EditComponentDepsWrapper.render:
        let objThemeOwnAndParent = appTheme.getThemeOwnAndParentvalues(this.props);
        let ownValues = objThemeOwnAndParent.ownValues;
        let parentValues = objThemeOwnAndParent.parentValues;

        let rows = _.map(this.props.value, (obj, i) => {
            let obj2 = appTheme.setProperInheritedFlag(
                obj,
                ownValues,
                parentValues,
                'ChartConstantLinesField_inThemes'
            );
            //LL: may be null, if just removed
            if (obj2 == null) {
                return null;
            }

            return (
                <ChartConstantLinesFieldRow
                    key={i + '-' + obj2.type}
                    i={i}
                    value={obj2}
                    themeObj={this.props.themeObj}
                    themeFields_forDefaultColors={options.themeFields_forDefaultColors}
                    //themeFieldForConstantLineList={options.themeFieldForConstantLineList}
                    prohibitAsPercent_byAxisType_byAxisObjX={prohibitedAsPercent_byAxisType_byAxisObjX}
                    prohibitAsPercent_byAxisType_byAxisObjY={prohibitedAsPercent_byAxisType_byAxisObjY}
                    secondaryAxisArr={secondaryAxisArr}
                    values={props_values}
                    prohibitedAsPercent_byAttrQuery_X_multi={prohibitedAsPercent_byAttrQuery_X_multi}
                    prohibitedAsPercent_byAttrQuery_Y_multi={prohibitedAsPercent_byAttrQuery_Y_multi}
                    glob={this.props.glob}
                    onChange={this.changeRow}
                    onRemove={this.removeRow}
                />
            );
        });

        //LL: 01.06.20:  must have "name"   className="cell-name"
        let thName = <th className="cell-name">{'Name'}</th>;

        //LL: 19.06.24: Date vs DateTime
        //    <p>Values: format for Dates is 'yyyy-mm-dd hh:mm:ss', for Time is 'hh:mm:ss'</p>
        //LL: use cell-color for both color and fontColor
        return (
            <div className={'chartconstantlines-field'}>
                <div className="chartconstantlines-field-common">
                    <p>
                        Values: format for DateTime is 'yyyy-mm-dd hh:mm:ss', for Date is 'yyyy-mm-dd', for Time is
                        'hh:mm:ss'
                    </p>
                    <p>"As Percent" can be used only for numeric continuous axis</p>
                </div>
                <div className={'div-container'}>
                    <div className="chartconstantlines-field-common"></div>
                    <table className={'table' + (this.props.border === true ? ' table-bordered' : '')}>
                        <thead>
                            <tr>
                                <th className="cell-remove"></th>
                                {thName}
                                <th className="cell-type">Axis</th>
                                <th className="cell-axisType">Axis Type</th>
                                <th className="cell-label">Label</th>
                                <th className="cell-asPercent" title="get Value from DataSource">
                                    From Data Source
                                </th>
                                <th
                                    className="cell-Value"
                                    title="format for DateTime 'yyyy-mm-dd hh:mm:ss', for Date 'yyyy-mm-dd', for Time 'hh:mm:ss'"
                                >
                                    Value / Data Source
                                </th>
                                <th className="cell-asPercent">As Percent</th>
                                <th className="cell-dashStyle">Dash Style</th>
                                <th className="cell-width">Width</th>
                                <th className="cell-color">Color</th>
                                <th className="cell-color">Font Color</th>
                                <th className="cell-labelPosition">Label Position</th>
                                <th className="cell-labelAlignment">Label Vertical Alignment</th>
                                <th className="cell-labelAlignment">Label Horizontal Alignment</th>
                            </tr>
                        </thead>

                        <tbody
                            ref={(input) => {
                                this.references.tableBody = input;
                            }}
                        >
                            {rows}
                            <ChartConstantLinesFieldRow
                                secondaryAxisArr={secondaryAxisArr}
                                themeObj={this.props.themeObj}
                                //themeFieldForConstantLineList={options.themeFieldForConstantLineList}
                                glob={this.props.glob}
                                onChange={this.addRow}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
